// src/app/services/chat/chat.service.ts
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError,tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

import { HttpService } from '../http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private sessionId: string = this.generateSessionId();
  constructor(private httpService: HttpService) {}

  /** Send a chat message (same coding pattern as cityService.getallcity) */
  send(message: string): Observable<any> {
    // const url = `${environment.AiApiendpoint}/texttosql`;   // adjust env key if needed
    const url = `${environment.AiApiendpoint}/chat`;   // adjust env key if needed
    const payload = { message };
    //  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpService
      .post(url, payload, this.httpService.headers)
      .pipe(catchError(this.handleError));
  }

  ask(message: string): Observable<any> {
    const url = `${environment.AiApiendpoint}/ask`;   // adjust env key if needed
    const payload = { message, sessionId: this.sessionId };
    console.log(`Sending message: ${message} with sessionId: ${this.sessionId}`);

    return this.httpService
      .post(url, payload, this.httpService.headers)
      .pipe(
        catchError(this.handleError),
        tap((response: any) => {
             const intent = response?.intent;
            const orderId = response?.orderId;
            if (response.need_expire_session) {
                this.sessionId = this.generateSessionId();
                this.clearClientMemory();
            }

            if (intent && orderId) {
                this.sessionId = this.generateSessionId();  // reset sessionId if needed
                this.clearClientMemory();                   // clear lastIntent from localStorage
            }

            // Optional: handle switching between intents too
            // If previous lastIntent is different from current intent, clear memory
            const lastIntent = JSON.parse(localStorage.getItem('lastIntent') || '{}');
            if (lastIntent?.intent && lastIntent.intent !== intent) {
                this.clearClientMemory();
            }

        })
      );
    //   .pipe(catchError(this.handleError));
  }
  private generateSessionId(): string {
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
  }
  private clearClientMemory() {

    localStorage.removeItem('lastIntent');
 }
  /* --- identical lightweight error helper to cityService.Errorhandling --- */
  private handleError(err: HttpErrorResponse) {
    if (err.error instanceof ErrorEvent) {
      console.error(err.error.message);
    } else {
      console.error(`Backend returned code ${err.status}`);
    }
    return throwError(() => 'Please try again later.');
  }
}
